export default function ActionBlockTemplate(data
) {
var out='<li class="k-state-active" style="border-top: none;border-bottom:none;"> <div id="actionButtons" class="simple-row clearfix"></div></li>';return out;
};